import React, { useEffect, useState } from "react";

import { commerce } from "../lib/commerce";
import loadinggif from "../svg x gifs/Fast loading.gif";
import { Link } from "react-router-dom";
import { useResultContext } from "../../../src/app";

import { MdDone } from "react-icons/md";
function ProductPage({ onAddToCart }) {
  const [checkout1, setcheckout1] = useState(false);

  const { setactive, active } = useResultContext();

  const [loading, setloading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [prices, setprice] = useState();
  const [fixprices, fixsetprice] = useState();

  const [pro, setpro] = useState({});
  async function fetchPro(id) {
    const response = await commerce.products.retrieve(id);
    const { price } = response;
    setpro(response);
    setloading(false);
    setprice(Number(price.formatted));
    fixsetprice(Number(price.formatted));
  }
  useEffect(() => {
    const id = window.location.pathname.split("/");
    fetchPro(id[2]);
  }, []);

  function handleQuanity(param) {
    if (param === "decrease" && quantity > 1) {
      setQuantity(quantity - 1);
      setprice(prices - fixprices);
    }
    if (param === "increase" && quantity < 10) {
      setQuantity(quantity + 1);
      setprice(prices + fixprices);
    }
  }

  function Emptyproduct() {
    return (
      <div className="flex justify-center text-center flex-col mt-[140px]">
        <div className="flex justify-center items-center">
          <img src={loadinggif} alt="" />
        </div>
      </div>
    );
  }
  function Product() {
    return (
      <>
        <Link onClick={() => setactive(null)} to="/cart">
          <div
            className={`${
              checkout1
                ? "h-14 translate-y-[0%] duration-700 cursor-pointer w-full bg-primary-100 fixed bottom-0  shadow-[0_35px_60px_15px_rgba(0,0,0,1.5)] right-0 z-50 transform -translate-x-[0]   "
                : "h-14 translate-y-[100%] cursor-pointer w-full bg-primary-100 fixed bottom-0  shadow-[0_35px_60px_15px_rgba(0,0,0,1.5)] right-0 z-50 transform duration-700 -translate-x-[0]   "
            }z-[100000000]`}
          >
            <div className="flex space-x-5 justify-center items-center my-[14px]  text-white">
              <MdDone className="bg-white rounded-full md:w-8 md:h-8 w-6 h-6 text-primary-100 p-[3px]" />
              <h1 className="uppercase leading-3  font-font text-[15px] md:text-xl">
                Check out
              </h1>
            </div>
          </div>
        </Link>
        <div className="pt-32 tablet:pt-36 flex phone:flex-col phone:justify-center phone:text-center items-center    font-font1">
          <div className="w-2/4 phonex2:w-3/4">
            <img src={pro.image.url} alt="" />
          </div>
          <div className="w-2/4 phone:w-3/4 phonex2:w-[100%]">
            <h1 className="text-[60px] mdd:text-[40px] leading-[100px]">
              {pro.name}
            </h1>

            <p
              dangerouslySetInnerHTML={{ __html: pro.description }}
              className="text-gray-600 font-font font-medium max-w-[40rem]  "
            />

            <div className="flex items-center border-b-2 phone:justify-center phone:my-4  space-x-4">
              <div>
                <span className=" text-4xl  text-primary-100">$</span>
                <span className="text-[50px] mdd:text-[40px]">
                  {parseFloat(prices).toFixed(2)}
                </span>
              </div>
              <div className="w-[6px] h-[6px] bg-primary-100 rounded-full"></div>
              <div>
                <span className="font-font2 phone:flex phone:justify-center ">
                  1 x 250ml
                </span>
              </div>
            </div>

            <div className="flex space-x-5 mt-8 phone:justify-center items-center">
              <h1 className="text-sm">QUANTITY</h1>
              <button
                onClick={() => handleQuanity("decrease")}
                className="w-[21px] hover:bg-primary-200  h-[21px] group-hover:bg-white group-hover:text-primary-100 flex justify-center rounded-sm text-white items-center bg-primary-100"
              >
                -
              </button>
              <button className="text-lg font-bold2"> {quantity}</button>
              <button
                onClick={() => handleQuanity("increase")}
                className="w-[21px] hover:bg-primary-200  h-[21px]  group-hover:bg-white group-hover:text-primary-100 flex justify-center rounded-sm text-white items-center bg-primary-100"
              >
                +
              </button>
            </div>
            <button
              onClick={() => {
                setcheckout1(true);
                onAddToCart(pro.id, quantity);
              }}
              className="py-6 phone:w-full hover:bg-primary-200 duration-300 my-8 capitalize shadow-xl text-white px-6 md:px-10 rounded-md bg-primary-100"
            >
              add to cart
            </button>

            <div className="flex -space-x-[10px] phonex2:flex-wrap">
              <img
                className="object-cover border-2 border-white rounded-full h-10 w-10"
                src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80"
                alt=""
              />
              <img
                className="object-cover border-2 border-white rounded-full h-10 w-10"
                src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                alt=""
              />
              <img
                className="object-cover border-2 border-white rounded-full h-10 w-10"
                src="https://images.unsplash.com/photo-1542740348-39501cd6e2b4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                alt=""
              />
              <img
                className="object-cover border-2 border-white rounded-full h-10 w-10"
                src="https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                alt=""
              />
              <div
                className="object-cover justify-center items-center flex text-white bg-primary-100 border-2 border-white rounded-full h-10 w-10"
                src=""
                alt=""
              >
                +7
              </div>
              <span className="flex phonex2:text-left px-6 font-font font-medium text-primary-200 justify-center items-center">
                11 other people tried it today
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
  return <>{loading ? <Emptyproduct /> : <Product />}</>;
}

export default ProductPage;
